import { action, observable } from 'mobx';
import { GWPandLoyaltyGeoSettings } from '../../../../../globals';
import { fetchGifts } from './gwpUtils';

export const GWPstate = observable({
  currentGifts: null as null | Gift[],
});

const setCurrentGifts = action((rewards: Gift[]) => {
  GWPstate.currentGifts = rewards;
});

if (window.gwp_settings?.isGWPenabled) {
  Promise.all([fetchGifts(), GWPandLoyaltyGeoSettings()]).then(([data, { shouldRenderGWPforINTL }]) => {
    if (data) {
      setCurrentGifts(shouldRenderGWPforINTL ? data.gifts.filter((gift: Gift) => gift.enabled_for_intl) : data.gifts);
    }
  });
}

export interface Gift {
  title: string;
  tier: string;
  gift_type: string;
  variant_id: string;
  product_id: string;
  text_before_amount: string;
  amount_to_spend: number;
  text_after_amount: string;
  subtext_once_redeemable: string;
  image: string;
  image_alt_text: string;
  in_cart_message: string;
  auto_redeem: boolean;
  channels: string[];
  requires_account: boolean;
  enabled_for_intl: boolean;
}
